import {LOAD_EXCEPTIONS_ERROR, LOAD_EXCEPTIONS_LOADING, LOAD_EXCEPTIONS_SUCCESS} from "./actions";

const initialState = {
    data: [],
    loading: false,
    error: ''
};

export default function reduxSagaReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_EXCEPTIONS_LOADING: {
            return {
                ...state,
                loading: true,
                error:''
            };
        }
        case LOAD_EXCEPTIONS_SUCCESS: {
            return {
                ...state,
                data: action.data,
                loading: false
            }
        }
        case LOAD_EXCEPTIONS_ERROR: {
            return {
                ...state,
                loading: false,
                error: action.error
            };
        }
        default: {
            return state;
        }
    }
}